<template>
  <div>
    <VSelect
      v-model="activeItems"
      :label="label"
      :disabled="disabled || !foundItems.length"
      :readonly="true"
      :required="required"
      :items="foundItems"
      :outlined="isOutlined"
      :itemValue="itemValue"
      :validateAtInitialization="validateAtInitialization"
      :loading="loading"
      data-cy="selectComponent"
      @click.native.stop="showModal"
    />
    <SelectWithTreeviewModal
      :isVisible="isVisible"
      :items="items"
      :title="label"
      :rules="{ required }"
      :itemKey="itemValue"
      @hide="isVisible = false"
      @confirm="onConfirm"
    />
  </div>
</template>

<script>
import VSelect from '@/components/shared/widgets/forms/VuetifyInputs/VSelect.vue';
import SelectWithTreeviewModal from '@/components/shared/widgets/forms/SelectWithTreeviewModal.vue';

export default {
    components: {
        VSelect,
        SelectWithTreeviewModal,
    },
    props: {
        value: {
            type: [String, Array, Object],
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: false,
        },
        itemValue: {
            type: String,
            default: 'id',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        validateAtInitialization: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        isOutlined: {
            type: Boolean,
            default: false,
        },
        rules: {
            type: Object,
            default: () => ({ required: false }),
        },
    },
    data() {
        return {
            activeItems: [],
            isVisible: false,
        };
    },
    computed: {
        selectedItems() {
            return this.activeItems.length ? this.activeItems[0][this.itemValue] : null;
        },
        foundItems() {
            const items = this.activeItems.length ? [this.getItem(this.activeItems, this.items)] : [];
            return items.length && items[0] !== null ? items : this.items;
        },
    },
    watch: {
        value: {
            handler(newValue) {
                if (newValue !== null) this.activeItems = newValue;
                if (newValue === null) this.activeItems = [];
            },
            immediate: true,
        },
    },
    methods: {
        getItem(selectedItem, items) {
            let foundItem = null;
            for (let i = 0; i < items.length; i += 1) {
                if (items[i][this.itemValue] === selectedItem) {
                    foundItem = items[i];
                }
                if (!foundItem && items[i].children) {
                    foundItem = this.getItem(selectedItem, items[i].children);
                }
                if (foundItem) break;
            }
            return foundItem;
        },
        showModal() {
            if (!this.disabled && !this.readonly && this.items && this.items.length) {
                this.isVisible = true;
            }
        },
        onConfirm(requestPayload) {
            this.activeItems = requestPayload;
            this.isVisible = false;
            this.$emit('input', this.selectedItems);
        },
    },
};
</script>
